export default __webpack_public_path__ + "static/media/Top.f85d6149.png";